import { ReactElement, useEffect } from 'react';
import { FormikContextType } from 'formik';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import withComponentLoader from '../../../../hoc/withComponentLoader';
import AppWrappedInput from './AppWrappedInput';

/**
 * Multi-select input base component stylized to work with Custom App Request Form
 * @param {Object} props component properties
 * @param {Function} props.setLoading setter function coming from `withComponentLoader` HOC
 * @param {string} props.label display text
 * @param {FormikContextType} props.formik full Formik Context
 * @param {string|ReactElement} props.helperText helper text
 * @param {string[]} props.options list of options to display.  Should be list of strings.
 * @param {boolean} props.isRequired flag to determine whether to show required indicator
 * @param {boolean} props.isLoading flag to indicate the loading state (comes from parent)
 * @param {boolean} props.isDisabled flag to indicate when component should be disabled
 * @param {object} props.props the rest of the props
 * @returns Multi-select input stylized for custom
 */
const AppWrappedSelect = ({
	setLoading,
	label,
	formik,
	helperText,
	options,
	isRequired = false,
	isLoading = false,
	isDisabled = false,
	...props
}) => {
	useEffect(() => {
		setLoading(isLoading);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isLoading]);

	return (
		<AppWrappedInput
			label={label}
			error={
				formik.touched[props.name] ? formik.errors[props.name] : null
			}
			isRequired={isRequired}
		>
			<FormControl variant='filled' fullWidth>
				<Select
					{...props}
					displayEmpty
					name={props.name}
					value={
						props.disabled ? 'VIEW ONLY' : formik.values[props.name]
					}
					onChange={formik.handleChange}
					onBlur={formik.handleBlur}
				>
					{props.disabled ? (
						<MenuItem key={5} value='VIEW ONLY'>
							{'VIEW ONLY'}
						</MenuItem>
					) : null}
					{!props.disabled && (
						<MenuItem disabled value=''>
							<em>Select option</em>
						</MenuItem>
					)}

					{options?.map((item, index) => (
						<MenuItem key={item.key} value={item.value}>
							{item.displayValue ?? item.value}
						</MenuItem>
					))}
				</Select>
				<FormHelperText>{helperText}</FormHelperText>
			</FormControl>
		</AppWrappedInput>
	);
};
export default withComponentLoader(AppWrappedSelect);
